import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle2 } from 'lucide-react';

const STEPS = [
  { n: 1, label: 'Find leads', href: '/portal/lead-discovery', desc: 'CQC register' },
  { n: 2, label: 'Sales CRM', href: '/portal/sales-leads', desc: 'Contact & follow-up' },
  { n: 3, label: 'Client org', href: '/portal/organisations', desc: 'Convert when committed' },
  { n: 4, label: 'Staffing request', href: '/portal/staffing-requests', desc: 'Role & dates' },
  { n: 5, label: 'Shifts', href: '/portal/shifts', desc: 'Assign workers' },
  { n: 6, label: 'Timesheets', href: '/portal/timesheets', desc: 'Approve → generate' },
  { n: 7, label: 'Payroll', href: '/portal/payroll', desc: 'Worker pay', admin: true },
  { n: 8, label: 'Invoices', href: '/portal/invoices', desc: 'Client billing', admin: true },
];

export default function StaffingPipelineGuide({ currentStep, compact = false }) {
  if (compact) {
    return (
      <p className="text-xs text-text-muted">
        Pipeline:{' '}
        {STEPS.map((s, i) => (
          <span key={s.n}>
            {i > 0 && ' → '}
            <Link
              to={s.href}
              className={currentStep === s.n ? 'font-semibold text-primary' : 'hover:underline'}
            >
              {s.label}
            </Link>
          </span>
        ))}
      </p>
    );
  }

  return (
    <div className="rounded-xl border bg-white shadow-sm overflow-hidden">
      <div className="px-4 py-3 border-b bg-gray-50 flex items-center gap-2">
        <CheckCircle2 className="h-4 w-4 text-primary" />
        <p className="text-sm font-semibold">End-to-end staffing pipeline</p>
      </div>
      <div className="p-4 grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-2">
        {STEPS.map((s, i) => (
          <Link
            key={s.n}
            to={s.href}
            className={`relative rounded-lg border p-3 text-center transition-colors hover:border-primary/40 hover:bg-primary/5 ${
              currentStep === s.n ? 'border-primary bg-primary/5 ring-1 ring-primary/20' : 'bg-white'
            }`}
          >
            <p className="text-[10px] font-bold text-primary uppercase">Step {s.n}</p>
            <p className="text-xs font-semibold mt-0.5">{s.label}</p>
            <p className="text-[10px] text-text-muted">{s.desc}</p>
            {s.admin && <p className="text-[9px] text-amber-700 mt-1">Admin</p>}
            {i < STEPS.length - 1 && (
              <ArrowRight className="hidden lg:block absolute -right-2.5 top-1/2 -translate-y-1/2 h-3 w-3 text-gray-300" />
            )}
          </Link>
        ))}
      </div>
      <p className="px-4 pb-4 text-[11px] text-text-muted">
        After shifts: approve attendance on Shifts → generate &amp; lock timesheets → payroll (worker pay) and invoices (client charge rates on Organisations) run in parallel.
      </p>
    </div>
  );
}